import { useEffect } from 'react';
import { DeviceOSType } from '@/api/user-portal-api-generated';
import { getMobilePlatform } from '@/features/onboarding/utils/mobile-platform';
import { getInjectedIosAppStoreId } from '@/utils/mobile-app-store';

interface UseMobileInstallAppProps {
  deepLinkUrl: string;
}

export function useMobileInstallApp({ deepLinkUrl }: UseMobileInstallAppProps) {
  const mobilePlatform = getMobilePlatform();

  const showPlayStore =
    mobilePlatform === DeviceOSType.ANDROID || mobilePlatform === null;
  const showAppStore =
    mobilePlatform === DeviceOSType.IOS || mobilePlatform === null;

  useIosSmartAppBanner({
    mobilePlatform,
    iosAppStoreId: getInjectedIosAppStoreId(),
    deepLinkUrl,
  });

  return {
    showPlayStore,
    showAppStore,
  };
}

interface UseIosSmartAppBannerProps {
  mobilePlatform: DeviceOSType | null;
  iosAppStoreId: string | null;
  deepLinkUrl: string;
}

function useIosSmartAppBanner({
  mobilePlatform,
  iosAppStoreId,
  deepLinkUrl,
}: UseIosSmartAppBannerProps) {
  useEffect(() => {
    if (mobilePlatform !== DeviceOSType.IOS || !iosAppStoreId) {
      return;
    }

    const meta = document.createElement('meta');
    meta.name = 'apple-itunes-app';
    meta.content = `app-id=${iosAppStoreId}, app-argument=${deepLinkUrl}`;
    document.head.appendChild(meta);

    return () => {
      document.head.removeChild(meta);
    };
  }, [mobilePlatform, iosAppStoreId, deepLinkUrl]);
}
